import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { StyledSelect } from '../../components/Select/Select.styles';
import { buttonStateMixin } from '../buttonStateMixin';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';
import { sizeMixin } from '../sizeMixin';
import { spacingMixin } from '../spacingMixin';
import { ChipMixin } from './ChipMixin';
var toggledOnCSS = function toggledOnCSS(props) {
  var isToggledOn = props.isToggledOn;
  if (!isToggledOn) {
    return '';
  }
  return token({
    backgroundColorHover: 'Chip.pressed.backgroundColorHover',
    borderWidth: 'Chip.pressed.borderWidth',
    horizontalSpacing: 'Chip.pressed.horizontalSpacing',
    chevronPadding: "Chip.pressed.chevronPadding",
    chevronPosX: "Chip.pressed.chevronPosX"
  }, function (_ref) {
    var backgroundColorHover = _ref.backgroundColorHover,
      borderWidth = _ref.borderWidth,
      chevronPadding = _ref.chevronPadding,
      chevronPosX = _ref.chevronPosX,
      horizontalSpacing = _ref.horizontalSpacing;
    return css(["", "", "", "{border-width:", "px;padding-top:0;padding-right:", "px;padding-bottom:0;padding-left:", "px;background-position:right -", "px center;", " ", ";}"], StyledSelect, StyledSelect, StyledSelect, borderWidth, chevronPadding, horizontalSpacing, chevronPosX, buttonStateMixin('Pressed')(Object.assign({
      buttonType: 'tertiary'
    }, props)), hoverMediaQueryMixin("\n          background-color: " + backgroundColorHover + ";\n        "));
  })(props);
};
var iconCSS = function iconCSS(props) {
  var icon = props.icon,
    isToggledOn = props.isToggledOn;
  if (!icon) {
    return '';
  }
  return token({
    chevronPadding: "Chip.chevronPadding",
    iconPosX: "Chip.pressed.iconPosX",
    pressedChevronPadding: "Chip.pressed.chevronPadding"
  }, function (_ref2) {
    var chevronPadding = _ref2.chevronPadding,
      iconPosX = _ref2.iconPosX,
      pressedChevronPadding = _ref2.pressedChevronPadding;
    return css(["", "{position:absolute;top:50%;left:", "px;transform:translateY(-50%);}", "", "", "", "{padding-left:", "px;}"], StyledIcon, iconPosX, StyledSelect, StyledSelect, StyledSelect, StyledSelect, isToggledOn ? pressedChevronPadding : chevronPadding);
  })(props);
};

/** @class FilterChipWithMenuMixin */
/** @method */
export var FilterChipWithMenuMixin = function FilterChipWithMenuMixin(props) {
  return token({
    borderWidth: "Chip.borderWidth",
    chevronPadding: "Chip.chevronPadding",
    chevronPosX: "Chip.chevronPosX",
    fontType: "Chip.fontType",
    height: "Chip.height"
  }, function (_ref3) {
    var borderWidth = _ref3.borderWidth,
      chevronPosX = _ref3.chevronPosX,
      chevronPadding = _ref3.chevronPadding,
      fontType = _ref3.fontType,
      height = _ref3.height;
    return css(["max-width:100%;position:relative;", "{", " justify-content:left;max-width:100%;padding-right:", "px;text-overflow:ellipsis;width:auto;", " ", " ", " &:active:not(:disabled){", "}&:active,&:hover,&:disabled,&:focus,&{background-position:right -", "px center;}}", " ", " ", ""], StyledSelect, ChipMixin(props), chevronPadding, buttonStateMixin()(Object.assign({
      buttonType: 'tertiary'
    }, props)), sizeMixin({
      fontType: fontType,
      borderWidth: borderWidth * 2,
      size: height
    })(props), hoverMediaQueryMixin(buttonStateMixin('Hover')(Object.assign({
      buttonType: 'tertiary'
    }, props))), buttonStateMixin('Active')(Object.assign({
      buttonType: 'tertiary'
    }, props)), chevronPosX, spacingMixin(props), iconCSS(props), toggledOnCSS(props));
  })(props);
};